import { render } from "./ResellerView.vue?vue&type=template&id=3726825a&scoped=true"
import script from "./ResellerView.vue?vue&type=script&lang=js"
export * from "./ResellerView.vue?vue&type=script&lang=js"

import "./ResellerView.vue?vue&type=style&index=0&id=3726825a&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3726825a"]])

export default __exports__